import ModalWrapper from '@Components/Modals/ModalWrapper/ModalWrapper';
import AccessoriesServices from '@Services/Accessories.services.ts';
import { Accessory } from '@Types/Asset.types';
import { handleRequestError } from '@Utils/request.utils';
import { ErrorDisplay, Toast } from '@kg-internal/pv3-uikit';
import { useState } from 'react';

type Props = {
  show: boolean;
  accessory?: Accessory;
  onClose: () => void;
  onSuccess: () => void;
};

const DeleteAccessoryModal = ({ show, accessory, onClose, onSuccess }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const deleteTaxStatus = () => {
    AccessoriesServices.disableAccessory(accessory?.id)
      .then(() => {
        Toast.success('Accessory deleted successfully.');
        onSuccess();
        onClose();
      })
      .catch((errorResponse) => handleRequestError(errorResponse, setErrorMessage, true));
  };

  return (
    <div className='modal--fit-content modal--w-30vw modal--pt-25vh'>
      <ModalWrapper
        title='Delete Accessory'
        show={show}
        handleClose={onClose}
        primaryButtonText='Confirm'
        primaryAction={() => deleteTaxStatus()}>
        {errorMessage ? (
          <ErrorDisplay inline details={errorMessage} />
        ) : (
          <div>
            <p>
              <b>Name</b> : {accessory?.name}
            </p>
            <br />
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default DeleteAccessoryModal;
